import { useOutletContext } from 'react-router-dom';
import InternalCalculator from '@/components/InternalCalculator';

export default function PartnerCalculatorPage() {
  const { partner } = useOutletContext();
  const token = localStorage.getItem('rpace_token');

  return (
    <div className="max-w-4xl mx-auto px-6 py-6 space-y-4" data-testid="partner-calculator-page">
      <div>
        <h1 className="text-xl font-bold text-slate-800">Readiness Calculator</h1>
        <p className="text-sm text-slate-500">Assess compliance status, estimate penalties and savings for client companies</p>
      </div>
      <InternalCalculator token={token} />
    </div>
  );
}
